/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_CatalogInputs */

const en_platform_catalog = /** @type {(inputs: Platform_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalog`)
};

const zh_hans1_platform_catalog = /** @type {(inputs: Platform_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录`)
};

const pt_br2_platform_catalog = /** @type {(inputs: Platform_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catálogo`)
};

const es_platform_catalog = /** @type {(inputs: Platform_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catálogo`)
};

const fr_platform_catalog = /** @type {(inputs: Platform_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogue`)
};

const de_platform_catalog = /** @type {(inputs: Platform_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog`)
};

const ru_platform_catalog = /** @type {(inputs: Platform_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каталог`)
};

const it_platform_catalog = /** @type {(inputs: Platform_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogo`)
};

/**
* | output |
* | --- |
* | "Catalog" |
*
* @param {Platform_CatalogInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_catalog = /** @type {((inputs?: Platform_CatalogInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_CatalogInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_catalog(inputs)
	if (locale === "pt-BR") return pt_br2_platform_catalog(inputs)
	if (locale === "es") return es_platform_catalog(inputs)
	if (locale === "fr") return fr_platform_catalog(inputs)
	if (locale === "de") return de_platform_catalog(inputs)
	if (locale === "ru") return ru_platform_catalog(inputs)
	if (locale === "it") return it_platform_catalog(inputs)
	return en_platform_catalog(inputs)
});